import styled from 'styled-components'

const CouponListSection = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;

  .info {
    display: block;
    line-height: 1;
    padding-bottom: 16px;
  }
`

const CouponItemWrapper = styled.div<{ borderTop: boolean }>`
  padding: 8px 0;
  border-top: ${({ borderTop }) => (borderTop ? '1px solid #eeeeee' : 'none')};
`

export { CouponListSection, CouponItemWrapper }
